<template>
  <ExTable :dataSource="dataSource">
    <DxColumn :allowEditing="false" caption="ID" data-field="Id"/>
    <DxColumn caption="Họ tên" data-field="CustomerName"/>
    <DxColumn caption="Ngày sinh" data-field="Dob"/>
    <DxColumn caption="Địa chỉ" data-field="Address"/>
    <DxColumn caption="Thành phố" data-field="City"/>
    <DxColumn caption="Tổng tiền" data-field="Price" data-type="number" format="currency"/>
    <DxColumn caption="Trạng thái" data-field="Status"/>
    <DxEditing
        :allow-adding="true"
        :allow-deleting="true"
        :allow-updating="true"
        mode="popup"
    />
  </ExTable>
</template>
<script>
import ExTable from "@/views/components/ExTable.vue";
import {DxColumn, DxEditing} from "devextreme-vue/data-grid";

export default {
  components: {
    DxColumn, DxEditing,
    ExTable
  },
  created() {
  },
  data() {
    return {
      dataSource: {
        store: {
          type: 'odata',
          version: 4,
          url: 'https://crm.itel.dev/api/tool/odata.svc/DemoOrders',
          key: 'Id',
          beforeSend: (e) => {
            e.headers = {
              'apiKey': localStorage.getItem('accessToken')
            };
          }
        },

      },
    };
  },
};
</script>
<style>
#gridContainer {
  height: 80vh;
}
</style>
